/**
 * <ReconnectNotice> — says "can't reach the server" while a session refresh is
 * failing for want of a server and is being retried (see `retryRefreshLater`).
 * The session is kept throughout; this only explains why screens are failing.
 * `pointer-events-none`, so it can never cover a control.
 */
import { useSyncExternalStore, type JSX } from "react";
import { useTranslation } from "react-i18next";
import { isReconnecting, subscribeReconnecting } from "../refresh/proactiveTimer.js";

export function ReconnectNotice(): JSX.Element {
  const { t } = useTranslation("common");
  const reconnecting = useSyncExternalStore(subscribeReconnecting, isReconnecting, () => false);
  // The live region stays mounted and only its text changes: a region that
  // appears together with its text is often not announced at all.
  return (
    <div
      role="status"
      className={
        reconnecting
          ? "pointer-events-none fixed inset-x-0 top-sm z-[60] mx-auto w-fit max-w-[calc(100%-2*var(--spacing-lg))] rounded-full border border-warning/40 bg-warning-soft px-md py-xs text-label text-default shadow-md"
          : "sr-only"
      }
    >
      {reconnecting ? t("network.unreachable") : null}
    </div>
  );
}
